<template>
  <div class="manage-campaign col-md-12">
        <h2>Manage Campaign</h2>
        <table>
          <tr style="border-bottom: 1px solid #000;">
            <th>Name</th>
            <th>Status</th>
            <th>Geo-Targeting Type</th>
            <th>Benefit Package</th>
            <th>Campaign Budget</th>
          </tr>
          <tr v-for="camp in campaigns" :key="camp.id" v-if="campaigns.length">
            <td>
              <h5>{{ camp.campaign_name }}</h5>
              <ul>
                <li><router-link :to="'/sadmin/' + camp.id +  '/quick-review'">Quick Review</router-link></li>
                <li><router-link :to="'/sadmin/' + camp.id +  '/advanced-review'">Advanced Review</router-link></li>
                <li><a href="#" @click="setCampValue(camp.id);" data-toggle="modal" data-target="#exampleModal">Add notes</a></li>
              </ul>
            </td>
            <td>
              <button style="border: 0px;" class="awaiting_approval">Awaiting Approval</button>
            </td>
            <td>{{ camp.geo_location_type }}</td>
            <td>{{ camp.package_name }}</td>
            <td>{{ camp.campaign_budget }}</td>
          </tr>
          <tr v-if="campaigns.length == 0">
            <td style="text-align: center; font-size: 18px;" colspan="5">No Pending Campaign For Approval</td>
          </tr>
          <!-- <tr>
            <td>
              <h5>Campaign B <img src="/img/Edit.png"></h5>
              <ul>
                <li><a href="#">Quick Review</a></li>
                <li><a href="#">Launch</a></li>
                <li><a href="#">Add notes</a></li>
              </ul>
            </td>
            <td>
                <a href="#" class="approved">Approved</a>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>
              <h5>Campaign C <img src="/img/Edit.png"></h5>
              <ul>
                <li><a href="#">View Activities</a></li>
                <li><a href="#">View Live Metrics</a></li>
                <li><a href="#">Add notes</a></li>
              </ul>
            </td>
            <td>
                <a href="#" class="launched">Launched</a>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>
              <h5>Campaign D <img src="/img/Edit.png"></h5>
              <ul>
                <li><a href="#">Quick Review</a></li>
                <li><a href="#">Add notes</a></li>
              </ul>
            </td>
            <td>
                <a href="#" class="need_more_information">Need more information</a>
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr> -->

        </table>
<div class="modal fade note_popup" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Add a Note</h3>
      </div>
      <div class="modal-body">
        <h5>Leave a note for brand</h5>
        <textarea placeholder="Type your notes here" v-model="note" name="note"></textarea>
      </div>
      <div class="center">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" ref="exitModel">Exit</button>
        <button type="button" class="btn btn-primary" @click="sendCampaignNote();">Send</button>
      </div>
    </div>
  </div>
</div>
      </div>
</template>

<script>
export default {
  name: 'PlgCampaigns',
  data () {
    return {
      sort: 'id-DESC',
      rowsOffset: 0,
      rowsLimitPerRequest: 100,
      note: '',
      picklCampId: '',
      campaigns: []
    }
  },
  mounted () {
    this.getCampaigns()
  },
  methods: {
    getCampaigns () {
      this.loadingStaff = true
      let q = { sort: this.sort, limit: this.rowsLimitPerRequest, offset: this.rowsOffset }
      this.$http
        .get('plg/manage-campaigns', { params: q })
        .then(
          function (response) {
            if (this.rowsLimitPerRequest === q.limit && this.rowsOffset === q.offset && this.storeSearchQuery === q.name) {
              this.rowsOffset += this.rowsLimitPerRequest
              this.campaigns.push(...response.body)
              if (this.campaigns.length === response.body.count) {
                this.hasMoreStaff = false
              } else {
                this.hasMoreStaff = true
              }
              this.loadingStaff = false
            }
          }
        )
    },
    approveCamp (campId) {
      let data = { campId: campId }
      this.$http
        .post('plg/approve-campaigns', data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Campaign has been successfully approved and is ready to launch!' })
          this.busy = false
          this.campaigns = []
          this.getCampaigns()
        })
    },
    setCampValue (campId) {
      this.picklCampId = campId
    },
    sendCampaignNote () {
      if (this.note === '') {
        this.$notify({ type: 'error', text: 'Please enter notes' })
        return false
      }
      let data = { campId: this.picklCampId, note: this.note }
      this.$http
        .post('plg/send-campaign-note', data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Note successfully sent' })
          this.busy = false
          this.$refs.exitModel.click()
          this.campaigns = []
          this.getCampaigns()
        })
    }

  }
}
</script>
<style>
.button-box{
    text-align: center;
    padding: 35px 0;
}
.camp_sett.button-box button {
    border: 0px;
    padding: 6px 30px;
    font-size: 20px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    background: #DBDBDB;
    border-radius: 8px;
    margin: 0 10px;
    display: inline !important;
    color: #000;
}
.form-box input{
    border: 0px;
    background: transparent;
    text-transform: uppercase;
    margin-left: 10px;
    outline: none;
}
.camp_sett.button-box .save-continue{
    color: #fff !important;
    background: #12DA6D !important;
}
.campaign-index .box img{
    max-height: 240px;
}
.campaign-index .col-md-5 {
    padding-left: 30px;
}
.form-sidebar {
    border: 3px solid #C7F5DD;
    padding: 20px;
    border-radius: 13px;
    background: #fff;
    margin-bottom: 30px;
    position: relative;
}
.step-number img {
    width: 38px;
}
.step h6{
    margin-top: 10px;
    color: #AAAAAA;
    font-size: 16px;
}
.campaign-index ul{
  list-style: none;
}
.want-to-engage {
  margin-top: 20px;
}
header ul li img {
    height: 30px;
}
.logo img{
  width: 150px;
}
header{
    padding: 10px 0;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
}
header .col-md-6 li{
  display: inline;
  margin-left: 12px;
}
header .col-md-6 ul{
    float: right;
    margin-bottom: 0px;
    padding: 3.5px 0;
}
header .col-md-6 ul li a {
    color: #000;
    text-decoration: none;
    font-family: "Roboto", sans-serif;
}
header ul li img {
    height: 30px;
}
.manage-campaign table{
    width: 100%;
    border: 1px solid #000;
    margin-bottom: 50px;
}
.manage-campaign h2 {
    text-align: center;
    color: #782B55;
    margin-top: 35px;
    margin-bottom: 20px;
    font-weight: 700;
}
.manage-campaign tr td{
    border-right: 1px solid #000;
}
.manage-campaign th{
    text-align: center;
    font-weight: normal;
    color: #000;
    padding: 8px 5px;
}
.manage-campaign td ul{
    padding: 15px !important;
    border: 1px solid #000;
}
.manage-campaign td ul li a{
    text-decoration: none;
    color: #000;
    font-size: 14px;
}
.manage-campaign td {
    padding: 10px;
}
.manage-campaign td ul li {
    padding-bottom: 4px;
    list-style: none;
}
.manage-campaign h5 {
    font-size: 17px;
    font-weight: normal;
    color: #000;
}
.manage-campaign h5 img{
    width: 19px;
    float: right;
}
.manage-campaign .awaiting_approval{
    background: #84ADE9;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .approved{
    background: #12DA6D;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .launched{
    background: #782B55;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .need_more_information{
    background: #FBBC05;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}

.center{
    text-align: center;
    padding-bottom: 30px;
}
.note_popup .modal-body {
    padding: 10px 20px 15px !important;
}
.note_popup .btn-primary{
    background: #55C287;
    border: 0px;
    padding: 6px 60px;
    font-size: 18px;
    border-radius: 8px;
    margin: 0 10px;
    width: 210px;
}
.note_popup .btn-secondary{
    background: #B4B4B7;
    width: 210px;
    border: 0px;
    padding: 6px 60px;
    font-size: 18px;
    color: #fff;
    border-radius: 8px;
    margin: 0 10px;
}
.note_popup textarea{
      height: 160px;
}
.note_popup .modal-header{
    padding-bottom: 0px;
}
.note_popup h3 {
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: center;
    color: #000;
    font-weight: 500;
}
.note_popup h5{
    font-weight: 500;
    margin-top: 0px;
}

</style>
